export const CHUNK_RECOVERY_MARKER_KEY = "ish:chunk-recovery-v3";
export const CHUNK_RECOVERY_HISTORY_KEY = "__ishChunkRecoveryV3";
export const CHUNK_RELOAD_COOLDOWN_MS = 30_000;
export const CHUNK_RECOVERY_CONFIRM_MS = 8_000;
export const CHUNK_RECOVERY_MARKER_TTL_MS = 5 * 60_000;

/**
 * The EXECUTABLE graph, and nothing else (rule 65).
 *
 * `/_next/static/` also holds `media/` — the content-hashed fonts, images and
 * other `next/font` + static-import assets. Those are decoration: when one fails
 * the browser falls back (system font, missing image) and the application keeps
 * running. Only a `.js` or `.css` asset can leave a seeker with a broken page,
 * and only those are what `proveCurrentDocumentChunkGraph` re-verifies after the
 * reload — so a wider TRIGGER than the prover's own graph can never terminalize
 * honestly. Both trigger owners (the pre-hydration bootstrap and the hydrated
 * `ChunkErrorReloader`) and the prover read this one definition.
 */
export const CHUNK_ASSET_PATH_PATTERN = "^/_next/static/.*\\.(?:js|css)$";

/** True only for a same-origin path that belongs to the executable chunk graph. */
export function isChunkGraphAssetPath(pathname: string | undefined | null): boolean {
  return Boolean(pathname) && new RegExp(CHUNK_ASSET_PATH_PATTERN).test(String(pathname));
}
